<template>
  <div id="app">
		<div id="pt-main" class="pt-perspective ">
      <transition 
        v-on:before-enter="beforeEnter"
        v-on:after-enter="afterEnter" 
        v-on:after-leave="afterLeave"
        v-on:before-leave="beforeLeave"
        :enter-active-class="enterActiveClass"
				:leave-active-class="leaveActiveClass"
      >
        <router-view/>
      </transition>
		</div>
  </div>
</template>

<style lang="scss">
@import "./assets/css/bootstrap.min.css";
</style>

<style>
@import "./assets/css/animations.css";
</style>

<style lang="scss">
@import "./assets/scss/style.scss";
</style>

<script>
import JQuery from "jquery";
const $ = JQuery;
export default {
  data: function() {
    return {
      pageDirection: "down",
      enterActiveClass: "pt-page-rotateCubeBottomIn",
      leaveActiveClass: "pt-page-rotateCubeBottomOut",
    }
  },
  methods: {
    beforeEnter: function (el) {
      $(el).removeClass('show-overflow')
    },
    beforeLeave: function (el) {
      $(el).removeClass('show-overflow')
    },
    afterEnter: function (el) {
      const $page = $(el)
      $page.addClass('show-overflow')

      // fire my after stuff here...
      this.fadeInContent( $page )
    },
    afterLeave: function (el) {
      $(el).addClass('show-overflow')
    },
    getPageDirection: function(from, to) {
      if (from == "/" && to == "/portfolio") {
        return "up";
      } else if (from == "/about" && to == "/") {
        return "up";
      } else if (from == "loading") {
        return "down";
      } else if (from == "/about" && to == "/resume") {
        return "right";
      } else if (from == "/resume" && to == "/about") {
        return "left";
      } else if (to == "/portfolio" && (from != "/" || from != "/index.html")) {
        return "left";
      } else if (to == "/portfolio/zverg" || to == "/portfolio/cravely" || to == "/portfolio/upwork" ) {
        return "right";
      } else {
        return "down";
      }
    },
    fadeInContent: function( $page ) {
      // add fade in transition
      if ($page.hasClass("pt-page-1")) {
        $page.find(".godown").addClass("animated fadeInDown");
      }

      if ($page.hasClass("pt-page-3")) {
        $page.find(".goup").addClass("animated fadeInUp");
      }

      if ($page.hasClass("pt-page-resume")) {
        $page.find(".header").addClass("animated fadeInDown");

        var $first = $(".first"),
          $firstDown = $first.find(".godown"),
          $firstLeft = $first.find(".goleft"),
          $firstRight = $first.find(".goright");

        setTimeout(function() {
          $firstDown.addClass("animated fadeInDown");
        }, 350);

        setTimeout(function() {
          $firstRight.addClass("animated fadeInRight");
          $firstLeft.addClass("animated fadeInLeft");
        }, 600);
      }
    }
  },
  watch: {
    $route: function(to, from) {
      this.pageDirection = this.getPageDirection( from.path, to.path );

      if (this.pageDirection == "up") {
        this.leaveActiveClass = "pt-page-rotateCubeBottomOut pt-page-ontop";
        this.enterActiveClass = "pt-page-rotateCubeBottomIn";
      } else if (this.pageDirection == "right") {
        this.leaveActiveClass = "pt-page-rotateCubeLeftOut pt-page-ontop";
        this.enterActiveClass = "pt-page-rotateCubeLeftIn";
      } else if (this.pageDirection == "left") {
        this.leaveActiveClass = "pt-page-rotateCubeRightOut pt-page-ontop";
        this.enterActiveClass = "pt-page-rotateCubeRightIn";
      } else {
        // down as default
        this.leaveActiveClass = "pt-page-rotateCubeTopOut pt-page-ontop";
        this.enterActiveClass = "pt-page-rotateCubeTopIn";
      }
    }
  },
};
</script>
